module.exports = __webpack_public_path__ + "img/how-to-play-page.58b0725d.png";